export const WriteRight = "WEB_MODULE_SETTINGS_PERSONAL_DATA_WRITE";
export const ReadRight = "WEB_MODULE_SETTINGS_PERSONAL_DATA_READ";

export const Rights = [
    WriteRight,
    ReadRight
]
